import {
  FETCH_PROFORMACONSTRUCTION_BEGIN,
  FETCH_PROFORMALISTS_SUCCESS,
  FETCH_PROFORMADATE_SUCCESS,
  FETCH_PROFORMAREBALANCEMETHOD_SUCCESS,
  FETCH_PROFORMABACKFILL_SUCCESS,
  FETCH_PROFORMATREELIST_SUCCESS,
  FETCH_PROFORMAENTITIES_SUCCESS,
  FETCH_PROFORMACONSTRUCTION_FAILURE,   
} from "../constants/Proforma";

const initialState = {
  ProformaListData: [], 
  ProformaDateData: [],
  ProformaRebalanceData: [],
  ProformaBackfillData: [],
  ProformaTreeListData: [],
  ProformaEntitiesData: [],
  error: "",
  isLoading:false
};

export const getProformaConstructionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PROFORMACONSTRUCTION_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_PROFORMACONSTRUCTION_FAILURE:
      return {
        ...state,
        isLoading: true,
        error: payload.error,
      };

    case FETCH_PROFORMALISTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ProformaListData: payload.ProformaListData,
      };
    case FETCH_PROFORMADATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ProformaDateData: payload.ProformaDateData,
      };
    case FETCH_PROFORMAREBALANCEMETHOD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ProformaRebalanceData: payload.ProformaRebalanceData,
      };
    case FETCH_PROFORMABACKFILL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ProformaBackfillData: payload.ProformaBackfillData,
      };
    case FETCH_PROFORMATREELIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ProformaTreeListData: payload.ProformaTreeListData,
      };
    case FETCH_PROFORMAENTITIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ProformaEntitiesData: payload.ProformaEntitiesData,
      };

    default:
      return state;
  }
};

export default getProformaConstructionReducer;
